import gql from 'graphql-tag';

export const DELETE_CUSTOMER_FILTER_GROUP = gql`
  mutation deleteCustomerFilterGroup($input: DeleteCustomerFilterGroupInput!) {
    deleteCustomerFilterGroup(input: $input) {
      customerFilterGroup {
        id
      }
    }
  }
`;
